import React, { Fragment, useContext, useState } from 'react';
import { useNavigate } from 'react-router';
import { UserAction, UserContext } from '../components/providers/UserProvider';
import { Card, Container, ContainerFlex, TextLocalized, Button, CustomInput } from '../components/styled/Styled';
import { HttpConnection, HttpMethod, HttpOperations } from '../components/util/HttpConnection';
import { checkValues, verifyEmailFormat } from '../components/util/UserUtil';

import login_img from '../img/login_img.jpg'
import logo from '../img/logo.svg';
import ButtonFlat from '../components/ButtonFlat';
import { LanguageContext } from '../components/providers/LanguageProvider';

const ForgetView = () => {
    const [formData, setFormData] = useState({ email: "", password: "", code: "" })
    const [requestedCode, setRequestedCode] = useState(false);

    const { dictionary } = useContext(LanguageContext);
    const { dispatch } = useContext(UserContext);

    let history = useNavigate();

    const onChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

    const sendRequest = () => {
        if (formData.email !== "") {
            if (verifyEmailFormat(formData.email)) {
                //Send request
                HttpConnection(`${HttpOperations.user}/code`,
                    result => setRequestedCode(true),
                    error => setRequestedCode(true),
                    HttpMethod.post, formData);
            } else {
                dispatch({ action: UserAction.showNoti, data: { show: true, color: "color-red", message: "errorEmailFormat" } })
            }
        } else {
            dispatch({ action: UserAction.showNoti, data: { show: true, color: "color-red", message: "errorOblData" } })
        }
    }

    const updatePassword = () => {
        if (checkValues(formData)) {
            if (verifyEmailFormat(formData.email)) {
                //Send request
                HttpConnection(`${HttpOperations.user}/reset`,
                    result => {
                        history("/login", { replace: true });
                        dispatch({ action: UserAction.showNoti, data: { show: true, color: "color-green", message: "msgSuccess" } });
                    },
                    error => {
                        dispatch({ action: UserAction.showNoti, data: { show: true, color: "color-red", message: "errorRecovery" } });
                    },
                    HttpMethod.post, formData);
            } else {
                dispatch({ action: UserAction.showNoti, data: { show: true, color: "color-red", message: "errorEmailFormat" } })
            }
        } else {
            dispatch({ action: UserAction.showNoti, data: { show: true, color: "color-red", message: "errorOblData" } })
        }
    }

    return (
        <ContainerFlex width="12" px="32" minheight="calc(100vh - 80px)" image={login_img} justify="center" align="center">
            <ContainerFlex width="12" height="100%" pv="32" justify="center" align="center">
                <Card width="12" lg="6" justify="center" shadowOn color="color-white" radius="20px">

                    <ContainerFlex width="12" px="16">
                        <ContainerFlex width="12" align="center" children={<img alt="logo" src={logo} height="48px" />} />
                        <ContainerFlex width="12" px="8" align="center" fontWeight="bold" children={<TextLocalized children="msgRecoveryPassword" />} />
                        <ContainerFlex width="12" ph="8" align="center" fontSize="12px" children={<TextLocalized children="msgRecoveryPasswordSubtitle" />} />
                    </ContainerFlex>

                    <Container width={"12"} height="1px" color="color-gray" />

                    <Container width="12" px="16">
                        <CustomInput onChange={onChange} disabled={requestedCode} width="12" inputmv="16" titleph="16" title={"msgEmail"} placeholder={dictionary["msgEmail"]} type="email" name="email" value={formData.email} />
                        {
                            requestedCode ?
                                <Fragment>
                                    <CustomInput onChange={onChange} width="12" inputmv="16" titleph="16" title={"msgCode"} placeholder={dictionary["msgCode"]} type="text" name="code" value={formData.code} />
                                    <CustomInput onChange={onChange} width="12" inputmv="8" titleph="16" title={"msgNewPassword"} placeholder={dictionary["msgNewPassword"]} type="password" name="password" value={formData.password} />

                                    <ButtonFlat mt="20" onClick={updatePassword} label={"actionUpdate"} fontColor="color-white" />
                                </Fragment>
                                :
                                <ButtonFlat onClick={sendRequest} label={"actionRequestCode"} fontColor="color-white" />
                        }

                        <Button onClick={() => history(-1)} flex justify="center" align="center" width="12" mv={16} height="54px"
                            border="solid" borderWidth="1px" borderColor={"color-primary"} color={"color-primary"} hoverColor={`color-primary-a50`} fontWeight="400" fontSize="13px" radius="12px"
                            letterSpacing="2px"
                            children={<TextLocalized children={"actionBack"} />} />


                    </Container>
                </Card>
            </ContainerFlex>
        </ContainerFlex>
    );
};

export default ForgetView;